export const GET_ALL_USER_SKILLS = 'GET_ALL_SKILL_MAPS';
export const GET_ALL_USER_SKILLS_SUCCESS = 'GET_ALL_SKILL_MAPS_SUCCESS';

export const GET_SELECTED_SKILL = 'GET_SELECTED_SKILL';
export const GET_SELECTED_SKILL_SUCCESS = 'GET_SELECTED_SKILL_SUCCESS';